export const tokens = {
  radius: { sm: 6, md: 10, lg: 14, xl: 20 },
  spacing: 8,
  shadow: {
    sm: '0 1px 2px rgba(0,0,0,.04), 0 1px 1px rgba(0,0,0,.02)',
    md: '0 4px 12px rgba(15,23,42,.06), 0 1px 2px rgba(15,23,42,.04)',
    lg: '0 12px 32px rgba(15,23,42,.10), 0 4px 12px rgba(15,23,42,.06)',
  },
  motion: {
    fast: '120ms cubic-bezier(.2,.8,.2,1)',
    base: '200ms cubic-bezier(.2,.8,.2,1)',
    slow: '320ms cubic-bezier(.2,.8,.2,1)',
  },
};

export const lightPalette = {
  primary: { main: '#0F172A', dark: '#020617', light: '#1E293B', contrastText: '#FFFFFF' },
  secondary: { main: '#C8A35A', dark: '#A08442', light: '#E0BD80', contrastText: '#0F172A' },
  background: { default: '#FAFAF7', paper: '#FFFFFF' },
  divider: '#E5E7EB',
  text: { primary: '#0F172A', secondary: '#64748B', disabled: '#94A3B8' },
  success: { main: '#10B981' },
  warning: { main: '#F59E0B' },
  error: { main: '#EF4444' },
  info: { main: '#3B82F6' },
};

export const darkPalette = {
  primary: { main: '#E2E8F0', dark: '#CBD5E1', light: '#F1F5F9', contrastText: '#0F172A' },
  secondary: { main: '#D4B574', dark: '#B69356', light: '#E5CB92', contrastText: '#0F172A' },
  background: { default: '#0B0F1A', paper: '#111827' },
  divider: '#1F2937',
  text: { primary: '#E2E8F0', secondary: '#94A3B8', disabled: '#64748B' },
  success: { main: '#34D399' },
  warning: { main: '#FBBF24' },
  error: { main: '#F87171' },
  info: { main: '#60A5FA' },
};
